export { O as Orientation } from './chunks/orientation.js';
export { C as CoreEvent, a as PausedReason, P as PlaybackState, b as PlayingChangeType, W as WaitingReason } from './chunks/event.js';
export { S as SessionClosedReason } from './chunks/event-handler.js';
export { a as PlaybackSessionError, P as PlaybackSessionErrorType } from './chunks/playback-session-error.js';
import './chunks/error.js';

const version = '11.0.0'; // Definitions:

export { version };
